const UserActivityCollectionFields = [
];

export default UserActivityCollectionFields;